import {
  Divider,
  Grid,
  Snackbar,
  Typography,
  Alert as MuiAlert,
  Skeleton,
  Card,
  CardContent
} from '@mui/material'
import { useEffect, useState, forwardRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { businessCheck } from '../../utils/utils'
import SubscriptionInfoComponet from '../subscriptions/subscription/subscriptionInfoComponent'
import NewSubscriptionPurchaseDrawer from './subscription/newSubscriptionPurchaseDrawer'
import { RAZORPAYKEY } from '../../utils/tsUtils/Env'
import {
  ConfirmationDialog,
  ErrorScreen,
  ShowNoRecordsFound,
  SnackBarHideDuration,
  SnackBarTransition
} from '../../utils/ui_utils'
import moment from 'moment'
import { Stack } from '@mui/system'
import { useFetchEntitlement } from '../../modules/entitlement/entitlementHooks'
import { useCreateRazorpayOrder } from '../../modules/razorpay/razorpayHooks'
import { useFetchByApplication } from '../../modules/plans/planHooks'
import { useSubscriptionOrderTypeFetch } from '../../modules/subscriptionPurchaseOrderType/subsOrderTypeHooks'
import {
  useCancelPurchaseOrderService,
  useCreatePurchaseOrderService,
  useFetchPurchaseOrderService,
  useUpdatePurchaseOrderService
} from '../../modules/subscriptionPurchaseOrderService/purchaseOrderServiceHooks'
import { useBusinessFetch } from '../../modules/business/businessHooks'

export var loadScript = function (src) {
  return new Promise((resolve) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = () => {
      resolve(true)
    }
    script.onerror = () => {
      resolve(false)
    }
    document.body.appendChild(script)
  })
}

function Subscription() {
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [selectedData, setSelectedData] = useState({})
  const [entitlementData, setEntitlementData] = useState({})
  const [till_date, setTill_Date] = useState('')
  let [noOfUsers, setNoOfUsers] = useState(0)
  let [subtotal, setSubTotal] = useState(0)
  let [total, setTotal] = useState(0)
  let orderId
  let purchase_order_id
  let [purchase_order_type, setPurchase_order_type] = useState('')
  let [cgstAmt, setCgstAmt] = useState(0)
  let [igstAmt, setIgstAmt] = useState(0)
  let [sgstAmt, setSgstAmt] = useState(0)
  let [net_amount, setNetAmount] = useState(0)
  let [purchaseForDays, setPurchaseForDays] = useState(0)
  const [pendingOrderData, setPendingOrderData] = useState([])
  const [maxuserFlag, setMaxuserFlag] = useState(false)
  const [suspend_users, setSuspend_users] = useState(0)

  const {
    fetchPlanByApplication,
    fetchPlanByApplicationData,
    fetchPlanByApplicationError,
    fetchPlanByApplicationLoading
  } = useFetchByApplication()
  const {
    fetchSubscriptionOrderType,
    subsOrderTypeData,
    subsOrderTypeError,
    subsOrderTypeLoading
  } = useSubscriptionOrderTypeFetch()
  const {
    fetchPurchaseOrderService,
    fetchPurchaseOrderServiceData,
    fetchPurchaseOrderServiceError,
    fetchPurchaseOrderServiceLoading
  } = useFetchPurchaseOrderService()
  const { createPurchaseOrderService } = useCreatePurchaseOrderService()
  const { updatePurchaseOrderService } = useUpdatePurchaseOrderService()
  const { cancelPurchaseOrderService } = useCancelPurchaseOrderService()
  const {
    fetchEntitlement,
    fetchEntitlementData,
    fetchEntitlementError,
    fetchEntitlementLoading
  } = useFetchEntitlement()
  const { fetchBusiness, businessData } = useBusinessFetch()
  const { createRazorpayOrder } = useCreateRazorpayOrder()
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [openCancelPopup, setOpenCancelPopup] = useState(false)
  const [confirmCancelPopup, setConfirmCancelPopup] = useState(false)

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  const history = useNavigate()

  useEffect(() => {
    businessCheck(history)
    fetchEntitlement()
    fetchSubscriptionOrderType()
    let payload = {
      pageNumber: 1,
      limit: 100,
      status: 'Pending'
    }
    fetchPurchaseOrderService(payload)
    payload.limit = 10
    fetchBusiness(payload)
  }, [])

  useEffect(() => {
    if (Object.keys(fetchEntitlementData)?.length > 0) {
      setEntitlementData(fetchEntitlementData)
      let payload = {
        pageNumber: page,
        limit: limit,
        application_id: fetchEntitlementData.current_plan.application._id
      }
      fetchPlanByApplication(payload)
    } else {
      setEntitlementData([])
    }
  }, [fetchEntitlementData])

  const [drawerState, setDrawerState] = useState(false)

  if (!parseInt(localStorage.getItem('credit_note'))) {
    localStorage.setItem('credit_note', 0)
  }

  let orderObj = {
    no_of_users: parseInt(noOfUsers),
    total_amount: +total,
    credit_note: parseInt(localStorage.getItem('credit_note')),
    net_amount: +net_amount,
    purchase_for_days: parseInt(purchaseForDays),
    purchased_items: [
      {
        plan_id: selectedData?._id,
        purchase_type_id: purchase_order_type._id,
        unit_price: selectedData?.price_per_user,
        qty: parseInt(noOfUsers),
        free_users: selectedData?.free_users,
        fixed_charge: selectedData?.fixed_charge,
        cgst: selectedData?.igst / 2,
        sgst: selectedData?.igst / 2,
        igst: selectedData?.igst,
        sgst_amount: sgstAmt,
        cgst_amount: cgstAmt,
        igst_amount: igstAmt
      }
    ]
  }

  const fetchEntitlementOnError = () => {
    fetchEntitlement()
    fetchSubscriptionOrderType()
    let payload = {
      pageNumber: 1,
      limit: 100,
      status: 'Pending'
    }
    fetchPurchaseOrderService(payload)
    payload.limit = 10
    fetchBusiness(payload)
  }

  const calculateOrder = (userCount) => {
    if (maxuserFlag === true) {
      return toastMessage(
        'Active Users are higher than the allowed users',
        'warning'
      )
    }
    let users = userCount
    let business_state = localStorage.getItem('BusinessDetails')
    let Sub_total = 0
    let Total = 0
    let _cgst = 0
    let _sgst = 0
    let _igst = 0
    let _net_amount = 0
    let Credit_note = fetchEntitlementData.credit_note
    if (users <= selectedData.max_users) {
      setNoOfUsers(userCount)
      if (selectedData.free_users === 0) {
        Sub_total =
          selectedData.fixed_charge + users * selectedData.price_per_user
      } else if (selectedData.fixed_charge === 0) {
        Sub_total = users * selectedData.price_per_user
      } else if (users > selectedData.free_users) {
        let diffuser = users - selectedData.free_users
        Sub_total =
          selectedData.fixed_charge + diffuser * selectedData.price_per_user
      } else {
        Sub_total = selectedData.fixed_charge
      }
      if (business_state == 'Karnataka') {
        _cgst = (Sub_total * (selectedData.igst / 2)) / 100
        _sgst = (Sub_total * (selectedData.igst / 2)) / 100
      } else {
        _igst = (Sub_total * selectedData.igst) / 100
      }
      Total = Sub_total + _cgst + _sgst + _igst
      if (Credit_note > Total) {
        _net_amount = 0
      } else if (Credit_note == Total) {
        _net_amount = Total - Credit_note
      } else if (Credit_note < Total) {
        _net_amount = Total - Credit_note
      }
      _net_amount = _net_amount.toFixed(0)
      Sub_total = Sub_total.toFixed(0)
      Total = Total.toFixed(0)

      setCgstAmt(_cgst)
      setSgstAmt(_sgst)
      setIgstAmt(_igst)
      setTotal(Total)
      setSubTotal(Sub_total)
      setNetAmount(_net_amount)
    } else {
      toastMessage(`Max Users Is Only ${selectedData.max_users}`, 'warning')
    }
  }

  const calculateOrderBeforeLoad = (plan) => {
    if (entitlementData == null) {
      return
    }
    // it takes user that entitlment data has.
    // let users = entitlementData.current_users
    //as per new requirement to make unlimited users for free but license keys are chargable. hence setting users as per plans's max_users.
    let users = plan?.max_users
    let business_state = localStorage.getItem('BusinessDetails')
    let Sub_total = 0
    let Total = 0
    let _cgst = 0
    let _sgst = 0
    let _igst = 0
    let _net_amount = 0
    let Credit_note = fetchEntitlementData.credit_note

    if (users > plan?.max_users) {
      users = 0
      let suspenduser = entitlementData.max_users - plan?.max_users
      if (suspenduser > 0) {
        setSuspend_users(suspenduser)
      }
      setMaxuserFlag(true)
    } else {
      setMaxuserFlag(false)
      setNoOfUsers(users)
      setPurchaseForDays(plan.plan_duration)
      if (plan?.free_users === 0) {
        Sub_total = plan?.fixed_charge + users * plan?.price_per_user
      } else if (plan?.fixed_charge === 0) {
        Sub_total = users * plan?.price_per_user
      } else if (users > plan?.free_users) {
        let diffuser = users - plan?.free_users
        Sub_total = plan?.fixed_charge + diffuser * plan?.price_per_user
      } else {
        Sub_total = plan?.fixed_charge
      }
      if (business_state == 'Karnataka') {
        _cgst = (Sub_total * (plan?.igst / 2)) / 100
        _sgst = (Sub_total * (plan?.igst / 2)) / 100
      } else {
        _igst = (Sub_total * plan?.igst) / 100
      }
      Total = Sub_total + _cgst + _sgst + _igst
      if (Credit_note > Total) {
        _net_amount = 0
      } else if (Credit_note <= Total) {
        _net_amount = Total - Credit_note
      }

      let suspenduser = entitlementData.max_users - plan?.max_users
      if (suspenduser > 0) {
        setSuspend_users(suspenduser)
      }
      setCgstAmt(_cgst)
      setSgstAmt(_sgst)
      setIgstAmt(_igst)
      setTotal(Total)
      setSubTotal(Sub_total)
      setNetAmount(_net_amount)
    }
  }

  const onOrderSaveClick = async () => {
    let returnSuccess = 1
    let usersCount
    if (noOfUsers != null || noOfUsers != undefined)
      usersCount = parseInt(noOfUsers)
    else usersCount = 0
    if (usersCount == 0 || isNaN(usersCount)) return

    for (let i = 0; i < Object.keys(subsOrderTypeData)?.length; i++) {
      if (subsOrderTypeData[i]?.short_name === 'New') {
        orderObj.purchased_items[0].purchase_type_id = subsOrderTypeData[i]?._id
        break
      }
    }
    if (fetchPurchaseOrderServiceData.data?.length === 0) {
      await createPurchaseOrderService(
        orderObj,
        (success, error, orderData) => {
          if (error) {
            toastMessage('Subscription Purchase order creation failed', 'error')
            returnSuccess = 0
          } else {
            let resp1 = orderData
            purchase_order_id = resp1.id
            setDrawerState(false)
            toastMessage('Successfully Saved Order', 'success')
          }
        }
      )
    } else {
      toastMessage('Pending Order already exists', 'warning')
      returnSuccess = 0
    }
    return returnSuccess
  }

  const updatePurchaseOrder = async () => {
    let usersCount
    if (noOfUsers != null || noOfUsers != undefined)
      usersCount = parseInt(noOfUsers)
    else usersCount = 0
    if (usersCount == 0 || isNaN(usersCount)) return

    let resp
    if (fetchPurchaseOrderServiceData.data?.length === 0) {
      await createPurchaseOrderService(
        orderObj,
        async (success, error, orderData) => {
          if (error) {
            toastMessage('Subscription Purchase order creation failed', 'error')
          } else {
            let resp1 = orderData
            resp = resp1.id
            orderObj.id = resp
            orderObj.payment_through = 'Credit Note'
            orderObj.status = 'Success'
            await updatePurchaseOrderService(orderObj, (success, error) => {
              if (error) {
                toastMessage('Subscription update failed', 'error')
              } else {
                fetchEntitlement()
                let payload = {
                  pageNumber: 1,
                  limit: 100,
                  status: 'Pending'
                }
                fetchPurchaseOrderService(payload)
                toastMessage('Subscription updated.', 'success')
                setDrawerState(false)
              }
            })
          }
        }
      )
    } else {
      toastMessage('Pending Order already exists', 'warning')
      setDrawerState(false)
    }
  }

  async function OpenPaymentGateway() {
    for (let i = 0; i < Object.keys(subsOrderTypeData)?.length; i++) {
      if (subsOrderTypeData[i]?.short_name === 'New') {
        orderObj.purchased_items[0].purchase_type_id = subsOrderTypeData[i]?._id
        break
      }
    }
    if (pendingOrderData?.length === 0) {
      if (orderObj.net_amount === 0) {
        updatePurchaseOrder()
      } else if (net_amount > 0) {
        displayRazorpay()
      }
    } else {
      toastMessage('Pending Order already exists', 'warning')
    }
  }

  async function displayRazorpay() {
    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')

    if (!res) {
      alert('Razorpay SDK failed to load. Are you online?')
      return
    }

    let body = {
      receipt: 'easypos_receipt#' + moment().unix(),
      amount: +net_amount,
      payment_capture: true
    }

    let data
    await createRazorpayOrder(body, (success, error, orderData) => {
      if (error) {
        toastMessage('Unable to create order. Try later', 'error')
        return
      } else {
        toastMessage('Order Created', 'success')
        data = orderData
      }
    })

    orderId = data.id
    const options = {
      key: RAZORPAYKEY,
      amount: data.amount,
      name: 'NGX',
      order_id: data.id,
      description: 'Subscription Payment',
      prefill: {
        name: '',
        email: '',
        contact: '',
        method: ''
      },
      modal: {
        confirm_close: true,
        escape: false
      },

      timeout: 600
    }
    options.modal.ondismiss = dismissModel.bind(this)
    options.handler = razorPaySuccessHandler.bind(this)

    const paymentObject = new window.Razorpay(options)
    if (onOrderSaveClick()) {
      setDrawerState(false)
      paymentObject.open()
    }
  }

  async function razorPaySuccessHandler(response) {
    orderObj.id = purchase_order_id
    orderObj.status = 'Success'
    orderObj.payment_through = 'Razorpay'
    orderObj.payment_order_id = response.razorpay_order_id
    orderObj.transaction_id = response.razorpay_payment_id

    await updatePurchaseOrderService(orderObj, (success, error) => {
      if (error) {
        toastMessage(
          'Subscrption update failed.\nIf Amount is debitted from your account, contact NGX',
          'error'
        )
        dismissModel(null, true)
      } else {
        fetchEntitlement()
        let payload = {
          pageNumber: 1,
          limit: 100,
          status: 'Pending'
        }
        fetchPurchaseOrderService(payload)
      }
    })
    toastMessage('Payment Done Successfully', 'success')
  }

  async function dismissModel(response, isPaymentSuccess = false) {
    orderObj.id = purchase_order_id
    orderObj.status = 'Failed'
    orderObj.payment_through = 'Razorpay'
    orderObj.payment_order_id = orderId

    await updatePurchaseOrderService(orderObj, (success, error) => {
      if (error) {
        toastMessage('Subscription update failed', 'error')
      } else {
        let payload = {
          pageNumber: 1,
          limit: 100,
          status: 'Pending'
        }
        fetchPurchaseOrderService(payload)
        fetchEntitlement()
      }
    })
    if (!isPaymentSuccess) toastMessage('Payment cancelled', 'error')
  }

  var convert = function (str) {
    var date = new Date(str)
    var mnth = `0${date.getMonth() + 1}`.slice(-2)
    var day = `0${date.getDate()}`.slice(-2)
    return [date.getFullYear(), mnth, day].join('-')
  }

  const CalculateTillDate = (plan) => {
    let tillDate1
    tillDate1 = new Date(fetchEntitlementData?.expiry_date)
    tillDate1.setDate(tillDate1.getDate() + plan.plan_duration)
    let convertedDate = convert(tillDate1)
    if (plan) {
      setTill_Date(convertedDate)
    }
    setDrawerState(true)
  }

  const setselectedplandata = (plan) => {
    setSelectedData(plan)
    calculateOrderBeforeLoad(plan)
    CalculateTillDate(plan)
  }

  const handleClickOpenCancelPopup = () => {
    setOpenCancelPopup(true)
  }

  const handleCloseOpenCancelPopup = () => {
    setOpenCancelPopup(false)
  }

  const handleClickOpenConfirmCancelPopup = () => {
    setOpenCancelPopup(false)
    setConfirmCancelPopup(true)
  }

  const handleCloseConfirmCancelPopup = () => {
    setConfirmCancelPopup(false)
  }

  const onConfirmCancelPlanClick = async () => {
    await cancelPurchaseOrderService((success, error) => {
      if (error) {
        toastMessage('Plan cancelled failed', 'error')
      } else {
        toastMessage('Plan cancelled successfully.', 'success')
        handleCloseConfirmCancelPopup()
        fetchEntitlement()
      }
    })
  }
  const PlanCancelPopUpDialog = () => (
    <div>
      <ConfirmationDialog
        visibility={openCancelPopup}
        okText="Continue"
        cancelText="Cancel"
        message="Before changing Subscription plan, current plan should be cancelled."
        title="Information"
        onCancel={handleCloseOpenCancelPopup}
        onOk={handleClickOpenConfirmCancelPopup}
      />

      <ConfirmationDialog
        visibility={confirmCancelPopup}
        okText="Yes"
        cancelText="No"
        message="Do you want to Proceed?"
        title="Confirmation"
        onCancel={handleCloseConfirmCancelPopup}
        onOk={async () => await onConfirmCancelPlanClick()}
      />
    </div>
  )

  return (
    <>
      <Helmet title="Subcriptions" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item xs={9}>
          <Typography variant="h4" gutterBottom display="inline">
            Subscription Plans
          </Typography>
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: 5, marginBottom: 5 }} />
      {fetchEntitlementError ? (
        <ErrorScreen
          onClick={() => {
            fetchEntitlementOnError()
          }}
        />
      ) : (
        <div>
          {fetchPlanByApplicationData?.length >= 0
            ? !fetchEntitlementError &&
              !fetchEntitlementLoading && (
                <>
                  <SubscriptionInfoComponet
                    okText={'Payment'}
                    changePlanText={'Change Plan'}
                    plansData={fetchPlanByApplicationData}
                    onSubmit={(plan) => {
                      setselectedplandata(plan)
                    }}
                    onCancelPlanClick={() => {
                      handleClickOpenCancelPopup()
                    }}
                    entitlementData={fetchEntitlementData}
                  />
                  <PlanCancelPopUpDialog />
                  <NewSubscriptionPurchaseDrawer
                    visible={drawerState}
                    title="Subscription Purchase Details"
                    entitlementData={fetchEntitlementData}
                    selectedPlan={selectedData}
                    noOfUsers={noOfUsers}
                    onClose={() => {
                      setDrawerState(false)
                      setNoOfUsers(0)
                      setTotal(0)
                      setSubTotal(0)
                      setNetAmount(0)
                      setPurchaseForDays(0)
                    }}
                    onPay={() => {
                      OpenPaymentGateway()
                    }}
                    onSave={() => {
                      onOrderSaveClick()
                    }}
                    calculationData={{
                      subtotal: subtotal,
                      total: total,
                      net_amount: net_amount,
                      tillDate: till_date,
                      suspend_users: suspend_users,
                      maxuserFlag: maxuserFlag
                    }}
                    onUserCountChange={(value) => {
                      calculateOrder(value)
                    }}
                  />

                  <div>
                    <Snackbar
                      open={snackbar}
                      autoHideDuration={SnackBarHideDuration}
                      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                      onClose={handleSnackbarClose}
                      TransitionComponent={SnackBarTransition}
                    >
                      <Alert onClose={handleSnackbarClose} severity={severity}>
                        {PopUpMessage}
                      </Alert>
                    </Snackbar>
                  </div>
                </>
              )
            : !fetchEntitlementError &&
              !fetchEntitlementLoading && <ShowNoRecordsFound />}
          {fetchEntitlementLoading ||
            (fetchPlanByApplicationLoading && (
              <Grid
                container
                justifyContent="center"
                spacing={10}
                sx={{ paddingTop: 5 }}
              >
                <Grid item sm={8} md={6}>
                  <Card raised sx={{ borderRadius: 3 }}>
                    <CardContent sx={{ flexGrow: 1 }}></CardContent>
                    <Stack spacing={3}>
                      <Grid container sx={{ ml: 5 }}>
                        <Grid item xs sm md>
                          <Grid container direction="column">
                            <Typography
                              variant="h4"
                              justifyContent={'center'}
                              sx={{ mb: 0.5 }}
                            >
                              <Skeleton
                                animation="wave"
                                variant="rectangular"
                                sx={{
                                  width: { xs: 50, sm: 50, md: 500 },
                                  height: 50
                                }}
                              />
                            </Typography>
                            <Grid
                              container
                              justifyContent="center"
                              sx={{ paddingTop: 5, ml: 8 }}
                            >
                              <Grid item sm md>
                                <Typography variant="h6" sx={{ mb: 0.5 }}>
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    width={200}
                                    height={25}
                                  />
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              justifyContent="space-arround"
                              sx={{ paddingTop: 3, ml: 8 }}
                            >
                              <Grid item sm={3} md={3}>
                                <Typography variant="h6" sx={{ mb: 0.5 }}>
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    width={200}
                                    height={25}
                                  />
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              justifyContent="space-arround"
                              sx={{ paddingTop: 3, ml: 8 }}
                            >
                              <Grid item sm={3} md={3}>
                                <Typography variant="h6" sx={{ mb: 0.5 }}>
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    width={200}
                                    height={25}
                                  />
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              justifyContent="space-arround"
                              sx={{ paddingTop: 3, ml: 8 }}
                            >
                              <Grid item sm={3} md={3}>
                                <Typography variant="h6" sx={{ mb: 0.5 }}>
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    width={200}
                                    height={25}
                                  />
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              justifyContent="space-arround"
                              sx={{ paddingTop: 3, ml: 8, mb: 5 }}
                            >
                              <Grid item sm md>
                                <Typography variant="h6" sx={{ mb: 0.5 }}>
                                  <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    width={200}
                                    height={25}
                                  />
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Stack>
                  </Card>
                </Grid>
              </Grid>
            ))}
        </div>
      )}
    </>
  )
}

export default Subscription
